<template>
  <div id="bars" :style="styles"></div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pie");

export default {
  name: "bars",
  props: {
    axis_name: String,
    series_name: String,
    volume_data: Array,
    // grid: Array,
    styles: String,
    year: Number,
    month: Number,
    is_loading: Boolean,
  },
  data() {
    return {
      chart: {},
    };
  },
  watch: {
    volume_data(new_val) {
      this.chart.showLoading();
      this.volume_data = new_val;
      this.draw();
    },
    is_loading(new_val) {
      new_val ? this.chart.showLoading() : this.chart.hideLoading();
    },
  },
  mounted() {
    this.chart = echarts.init(document.getElementById("bars"));
    this.chart.showLoading();
  },
  methods: {
    draw() {
      if (!this.volume_data) return;

      const _this = this;
      let yAxisData = [];
      let thisData = [];
      let lastData = [];
      let seriesData = [];
      let pieData = [];
      let legendData = [];
      for (let project of _this.volume_data) {
        yAxisData.push(Object.values(project)[0]);
        thisData.push(Object.values(project)[1]);
        lastData.push(Object.values(project)[2]);
        pieData.push({
          name: Object.values(project)[0],
          value: Object.values(project)[1],
        });
      }
      yAxisData.reverse();
      legendData = JSON.parse(JSON.stringify(yAxisData)).reverse();

      if (yAxisData.length >= 10) {
        let sumPie = pieData.reduce((sum, item) => {
          return sum + item.value;
        }, 0);
        pieData.push({
          name: "其他",
          value: Object.values(_this.volume_data[0])[3] - sumPie,
        });
        legendData.push("其他");
      }

      seriesData.push(
        {
          name: this.year + "-" + this.month,
          type: "bar",
          barWidth: 12,
          barCategoryGap: 10,
          label: {
            normal: {
              show: true,
              formatter: function (param) {
                return param.value.toLocaleString();
              },
              color: "#00578F",
              position: "right",
            },
          },
          data: thisData.reverse(),
        },
        {
          name: this.year - 1 + "-" + this.month,
          type: "bar",
          barWidth: 12,
          barCategoryGap: 10,
          label: {
            normal: {
              show: true,
              formatter: function (param) {
                return param.value.toLocaleString();
              },
              color: "#C3C3C3",
              position: "right",
            },
          },
          data: lastData.reverse(),
        },
        {
          //   name: "pie",
          type: "pie",
          radius: [0, "55%"],
          center: ["75%", "38%"],
          color: [
            "#BAD1E1",
            "#A3C2D6",
            "#94B9D0",
            "#82ADC8",
            "#70A1C0",
            "#5C94B8",
            "#4C89B0",
            "#3D7FAA",
            "#2E75A3",
            "#1F6C9D",
            "#0F6195",
            "#00578F",
          ].reverse(),
          tooltip: {
            trigger: "item",
            // formatter: "{b} : {c} ({d}%)",
            borderColor: "#FFFFFF",
            formatter: (param) => {
              let list = [];
              // if(param)
              // {
              //   list.push('<span style="font-size:12px;color:#6e7079;margin-left:2px">' + param?.name + '</span><div style="clear:both"></div>')
              // }
              let listItem = "";
              list.push(
                param.marker +
                  '<span style="font-size:12px;color:#6e7079;margin-left:2px">' +
                  // param.seriesName
                  param?.name +
                  "</span>：" +
                  '<span style="font-size:12px;margin-left:5px;">' +
                  param.value.toLocaleString() +
                  "</span>" +
                  '<div style="clear:both"></div>'
              );
              listItem = list.join("");
              return listItem;
            },
          },
          label: {
            position: "inner",
            // fontSize: 10,
            // formatter: "{d}%",
            formatter: function (data) {
              return data.percent.toFixed(0) + "%";
            },
            // ellipsis: "...",
            color: "#FFFFFF",
            verticalAlign: "bottom",
          },
          itemStyle: {
            // borderRadius: 20,
            borderColor: "#fff",
            borderWidth: 1,
          },
          clockWise: false,
          data: pieData,
        }
      );
      const option = {
        title: {
          text: this.year + "年" + this.month + "月乘用车市场集中度情况",
          right: "14%",
          bottom: 0,
          textStyle: {
            fontWeight: 400,
            fontSize: 13,
          },
        },
        color: ["#00578F", "#C3C3C3"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          borderColor: "#FFFFFF",
          formatter: (params) => {
            let list = [];
            if (params) {
              list.push(
                '<span style="font-size:12px;color:#6e7079;margin-left:2px">' +
                  params[0]?.name +
                  '</span><div style="clear:both"></div>'
              );
            }
            let listItem = "";
            for (let param of params) {
              list.push(
                param.marker +
                  '<span style="font-size:12px;color:#6e7079;margin-left:2px">' +
                  param.seriesName +
                  "</span>：" +
                  '<span style="font-size:12px;margin-left:5px;">' +
                  param.value.toLocaleString() +
                  "</span>" +
                  '<div style="clear:both"></div>'
              );
            }
            listItem = list.join("");
            return listItem;
          },
        },
        legend: [
          {
            bottom: 0,
            left: "25%",
            // padding: [20, 52, 20, 52],
            data: [
              {
                name: this.year + "-" + this.month,
              },
              {
                name: this.year - 1 + "-" + this.month,
              },
            ],
          },
          {
            data: legendData,
            icon: "circle",
            top: "68%",
            left: "63%",
            width: "30%",
            itemWidth: 20,
            itemHeight: 10,
            // itemGap : 5,
            textStyle: {
              fontWeight: 400,
              fontSize: 10,
            },
          },
        ],
        grid: [{ x: "14%", y: "5%", width: "40%", height: "85%" }],
        xAxis: [
          {
            type: "value",
            show: false,
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: {
          name: _this.axis_name,
          nameTextStyle: {
            color: "#333333",
            padding: [0, 0, -10, 0],
          },
          axisLine: {
            lineStyle: {
              color: "#DDDDDD",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#333333",
            },
            rotate: 30,
            formatter: (word) => {
              var indexArr = [];
              var index = word.indexOf(" "); // 字符出现的位置
              if (index === -1 || word.length <= 14) {
                return word;
              }
              while (index !== -1) {
                indexArr.push(Math.abs(index - word.length / 2)); // 打印字符串出现的位置
                index = word.indexOf(" ", index + 1); // 从字符串出现的位置的下一位置开始继续查找
              }
              var res = "";
              var location = indexArr.indexOf(Math.min.apply(Math, indexArr));
              var words = word.split(" ");
              for (let w in words) {
                let i = parseInt(w);
                if (
                  res.length + words[i].length > 14 &&
                  !res.endsWith("\n") &&
                  !res.endsWith(" ")
                ) {
                  res = res.trim() + "\n";
                  res += words[i];
                } else {
                  res += words[i];
                  if (i === location && i + 1 < words.length) {
                    res += "\n";
                  } else if (i + 1 !== words.length) {
                    res += " ";
                  }
                }
              }
              return res;
            },
          },
          axisTick: {
            show: false,
          },
          data: yAxisData,
        },
        series: seriesData,
      };

      this.chart.setOption(option, true);
      this.chart.hideLoading();
    },
  },
};
</script>
